export const pinEncryptKeyPair = atob(process.env?.REACT_APP_ENC_HELPER?.replace(/\\n/g, '\n') || '');
export const pinEncryptKeyPairPvt = atob(process.env?.REACT_APP_ENC_HELPER_PVT?.replace(/\\n/g, '\n') || '');
